var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "portal-rail" },
    [
      _c(
        "nav",
        { staticClass: "rail-navigation" },
        _vm._l(_vm.navigationGroups, function(group) {
          return _c(
            "div",
            { key: group.key, staticClass: "navigation-group" },
            _vm._l(group.links, function(link) {
              return _c("nav-link", {
                key: link.route || link.hyperLink,
                attrs: {
                  label: link.label,
                  icon: link.icon,
                  "custom-icon": link.customIcon,
                  route: link.route,
                  "alt-routes": (link.tabs || []).map(function(tab) {
                    return tab.route
                  }),
                  "hyper-link": link.hyperLink
                }
              })
            }),
            1
          )
        }),
        0
      ),
      _c(
        "v-menu",
        {
          attrs: {
            "offset-x": "",
            "nudge-left": "8",
            "content-class": "workspace-menu",
            "close-on-content-click": false
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "button",
                    _vm._g(
                      _vm._b(
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                placement: "right",
                                boundary: "window"
                              },
                              expression:
                                "{\n\t\t\t\t\tplacement: 'right',\n\t\t\t\t\tboundary: 'window',\n\t\t\t\t}"
                            }
                          ],
                          ref: "clientContext",
                          staticClass: "client-context",
                          class: { "is-collapsed": !_vm.expanded },
                          attrs: {
                            type: "button",
                            "aria-label": _vm.clientName,
                            content: _vm.clientName
                          }
                        },
                        "button",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("span", { staticClass: "client-avatar" }, [
                        _vm._v(_vm._s(_vm.clientInitials))
                      ]),
                      _vm.expanded
                        ? _c("span", { staticClass: "client-name" }, [
                            _vm._v(_vm._s(_vm.clientName))
                          ])
                        : _vm._e(),
                      _vm.expanded && _vm.hasMultipleClients
                        ? _c("portal-icon", {
                            staticClass: "client-switch-icon",
                            attrs: { name: "chevrons-up-down", size: 18 }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [_c("settings-nav")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }